

















import Vue from 'vue';

import { BFormInput, BInputGroup, BButton } from 'bootstrap-vue';

export default Vue.extend({
  name: 'TextFieldWithCopyButton',
  components: {
    BButton,
    BFormInput,
    BInputGroup,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      id: <string | null>null,
    };
  },
  mounted() {
    this.id = String(this._uid);
  },
  methods: {
    copyToClipboard() {
      let copyText = document.getElementById(this.id);
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/
      document.execCommand('copy');
    },
  },
});
